export default __webpack_public_path__ + "static/media/search.74dc9e41.svg";